(function() {
    'use strict';
    angular.module('wbDashboard').factory('FormulaService', ['FeatureFlagService', '$q', '$filter', 'Request', 'Track', function (FeatureFlagService, $q, $filter, Request, Track) {
        var data = {
                zeroState: true,
                user: {}
            },

            dataData = {
                'formulas' : null,
                'userFormulas' : null,
                'userWallet' : null,
            },
            promises = {
            };

        data.multipliers = {
            estRoundUp: 21 * 0.75,
            estDividend: 12,
        };

        /**
         * Returns entire dataData object
         */
        data.getDataData = function() {
            return data.get();
        };

        /**
         * Get specific dataData key
         * @param type
         * @returns {*}
         */
        data.get = function (type) {
            if (!type) {
                return dataData;
            } else {
                return dataData[type];
            }
        };
        /**
         * Clear any dataData key or entire object
         * @param type
         * @returns {boolean}
         */
        data.clear = function (type) {
            if (type) {
                if (!(type in dataData)) {
                    throw new Error("DataService: Invalid type in dataData");
                }
                dataData[type] = null;
            } else {
                Object.keys(dataData).forEach(function(key) {
                    dataData[key] = null;
                });
            }
            return true;
        };
        /**
         * Manually update any particular data in any dataData key
         * @param type
         * @param data
         */
        data.manualSet = function(type, data) {
            if (!(type in dataData)) {
                throw new Error("DataService: Invalid type in dataData");
            }
            dataData[type] = dataData[type] || {};
            dataData[type] = angular.extend(dataData[type], data);
        };

        data.enable = function() {
            if (data.isZero()) {
                return FeatureFlagService.markFeature('formulas').then(function () {
                    return data.isZero();
                });
            } else {
                return $q.when(1).then(function() { return data.isZero(); });
            }
        };
        data.isZero = function() {
            data.zeroState = FeatureFlagService.hasFeature('formulas');
            return data.zeroState;
        };

        /**
         * @returns {*}
         */
        data.getFormulas = function (slug) {
            var formulas = data.get('formulas');
            if (slug && formulas) {
                var returnFormulas = null;
                angular.forEach(formulas, function(f) {
                    if (f.slug === slug) {
                        returnFormulas = f;
                    }
                });
                return returnFormulas;
            } else {
                return formulas;
            }
        };
        /**
         * @returns {*}
         */
        data.retrieveFormulas = function (refresh) {
            if (data.getFormulas() && !refresh) {
                return $q.when(data.getFormulas());
            } else {
                return Request.make('formulas_available').then(function (response) {
                    dataData.formulas = response.data.response.formulas;
                    return dataData.formulas;
                }).catch(function() {
                    dataData.formulas = [
                        {
                            "slug": "round-up",
                            "title": "Round Up",
                            "description": "Automatically use your cash to round up milestones everyday.",
                        },
                        {
                            "slug": "bargain-hunting",
                            "title": "Bargain Hunting",
                            "description": "Automatically use your cash to buy low when your portfolio goes on sale.",
                        },
                        {
                            "slug": "multiply-dividends",
                            "title": "Dividend Match",
                            "description": "Multiply your dividends with cash and save even faster.",
                        },
                        {
                            "slug": "level-up",
                            "title": "Level Up",
                            "description": "Level up your milestones to the next $1,000 values using your cash.",
                        },
                    ];
                    return dataData.formulas;
                });
            }
        };

        data.getFormulasAutoRecommend = function(data) {
            // data._method = "GET";
            return Request.make('formulas_auto_recommend', data).then(function (response) {
                return response.data.response;
            });
        };

        data.saveFormula = function(data) {
            return Request.make("user_formulas_save", data).then(function(response) {
                return response.data.response;
            });
        };
        
        data.getConfirmText = function(formula = {}) {
            var confirmText = null;

            switch (formula.slug) {
                case 'round-up':
                    confirmText = `Round up my milestones to the nearest
                                    ${$filter('wbCurrency')(formula.metadata.round_up_amount)} each day.`;
                    break;
                case 'bargain-hunting':
                    confirmText = `Transfer ${$filter('wbCurrency')(formula.metadata.bargain_hunting_transfer)} when
                          my portfolio drops ${$filter('number')(formula.metadata.bargain_hunting_percent, 1)}% or more.`;
                    break;
                case 'multiply-dividends':
                    confirmText = `Multiply dividends by ${formula.metadata.multiply_dividend_multiple}x with cash transfers.`;
                    break;
                case 'level-up':
                    confirmText = `Transfer ${$filter('wbCurrency')(1000 - formula.metadata.level_up_amount)} to my
                                milestone when it reaches a ${$filter('wbCurrency')(formula.metadata.level_up_amount)} value.`;
                    break;
            }

            return confirmText;

        };
        data.getValueText = function(formula = {}) {
            var valueText = null;

            switch (formula.slug) {
                case 'round-up':
                    valueText = `${formula.metrics.formulas_executed} Round Ups`;
                    break;
                case 'bargain-hunting':
                    valueText = `${$filter('wbCurrency')(formula.metrics.total_amount_transferred)} Transferred`;
                    break;
                case 'multiply-dividends':
                    valueText = `${formula.metrics.formulas_executed} Dividends Multiplied`;
                    break;
                case 'level-up':
                    valueText = `${$filter('wbCurrency')(formula.metrics.level_up_achieved)} Level Reached`;
                    break;
            }

            return valueText;

        };
        data.getPotentialTransfer = function(formula = {}) {
            var value = null;

            switch (formula.slug) {
                case 'round-up':
                    //unused
                    value = 0;
                    // value = data.multipliers.estRoundUp * formula.metadata.round_up_amount ;
                    break;
                case 'bargain-hunting':
                    value = formula.metadata.bargain_hunting_transfer;
                    break;
                case 'multiply-dividends':
                    //unused
                    value = 0;
                    // value = data.multipliers.estDividend * formula.metadata.multiply_dividend_multiple;
                    break;
                case 'level-up':
                    value = 1000 - formula.metadata.level_up_amount;
                    break;
            }

            return value;

        };

        data.user.getWallet = function () {
            return data.get('userWallet');
        };
        data.user.getFormulas = function (slug) {
            var formulas = data.get('userFormulas');
            if (slug && formulas) {
                var returnFormulas = null;
                angular.forEach(formulas, function(f) {
                    if (f.slug === slug) {
                        returnFormulas = f;
                    }
                });
                return returnFormulas;
            } else {
                return formulas;
            }
        };
        data.user.retrieveFormulas = function (refresh) {
            if (data.user.getFormulas() && !refresh) {
                return $q.when(data.user.getFormulas());
            } else {
                return Request.make('user_formulas').then(function (response) {
                    dataData.userFormulas = response.data.response.formulas;
                    dataData.userWallet = response.data.response.wallet;

                    var totalTransfer = 0;
                    var totalExecuted = 0;
                    angular.forEach(dataData.userFormulas, function(formula) {
                        totalTransfer += formula.metrics.total_amount_transferred;
                        totalExecuted += formula.metrics.formulas_executed;

                        if (formula.metadata.bargain_hunting_percent) {
                            formula.metadata.bargain_hunting_percent = formula.metadata.bargain_hunting_percent * 100;
                            formula.metadata.bargain_hunting_percent = Math.round(formula.metadata.bargain_hunting_percent*100)/100;
                        }

                    });
                    dataData.userWallet.total_amount_transferred = totalTransfer;
                    dataData.userWallet.total_executed = totalExecuted;

                    dataData.userWallet.available_balance = Math.round(dataData.userWallet.available_balance*100)/100;

                    return dataData.userFormulas;
                });
            }
        };

        data.user.deleteFormula = function(slug) {
            return Request.make("user_formulas_delete", {formulaSlug: slug}).then(function(response) {
                return response.data.response;
            });
        };


        return data;
    }]);
})();
